﻿import accounting from 'accounting';

$(function () {
    $('.CreateBuildYourOwnProductSelector button[type="submit"]').on('click', function (e) {
        e.preventDefault();
        var form = $(this).parents('.CreateBuildYourOwnProductSelector');
        $.post(form.data('action'), { __RequestVerificationToken: form.find('input[name="__RequestVerificationToken"]').val(), ContainerId: $(this).val(), Locale: form.find('input[name="Locale"]').val(), js: true }, function (data) {
            UpdateByoContent(data);
            $('.byoCreateArea').addClass('d-none');
            $('.byoCurrentArea, .byoProductsArea').removeClass('d-none');
        });
        //console.log('sdsds');
    }).prop('disabled', false);

    $('.byoVariantProducts').hide();
    $('.byoVariantProducts[data-product="' + $('.byo-select').val() + '"]').show();

    $('.byo-select').on('change', function (e) {
        //console.log($(this).val());
        $('.byoVariantProducts').hide();
        $('.byoVariantProducts[data-product="' + $(this).val() + '"]').show();
    });

    $('.byoResetButton').on('click', function (e) {
        e.preventDefault();
        $.post($(this).attr('href'), function () {
            $('.byoCurrentContent').empty();
            $('.byoCreateArea').removeClass('d-none');
            $('.byoCurrentArea, .byoProductsArea').addClass('d-none');
            $('.byo-favourite-button').attr('title', $('.byo-favourite-button').data('addto'));
            $('.byo-favourite-button').find('span').text($('.byo-favourite-button').data('addto'));
            $('.byo-favourite-button').find('i').removeClass('fa-heart').addClass('fa-heart-o');
        });
    });

    $('.byo-favourite-button').on('click', function (e) {
        e.preventDefault();
        var actionType = 'add';
        if ($(this).find('i').hasClass('fa-heart-o')) {
            $(this).find('i').removeClass('fa-heart-o').addClass('fa-heart');
            $(this).find('span').text($(this).data('removefrom'));
            $(this).attr('title', $(this).data('removefrom'));
        } else {
            $(this).find('i').removeClass('fa-heart').addClass('fa-heart-o');
            $(this).find('span').text($(this).data('addto'));
            $(this).attr('title', $(this).data('addto'));
           actionType = 'remove';
        }
        $.post("/wishlist/addremove", {
            action: actionType, byoGuid: $(this).data('guid'), sku: $('.byoCurrentArea input[name="sku"]').val() }, function (data) {
            if (data > 0) {
                $('.top-nav-wish-list-link i').removeClass('fa-heart-o').addClass('fa-heart');
            } else {
                $('.top-nav-wish-list-link i').removeClass('fa-heart').addClass('fa-heart-o');
            }
        });
    });

    $('.plus-minus-byo-form button').on('click', function (e) {
        //console.log($(this).data('type'));
        var currentNumber = parseInt($(this).parents('form').find('.current-basket-value').text());
        if (currentNumber == 0) {
            currentNumber = 1;
        } else {
            if ($(this).data('type') == "plus") {
                currentNumber++;
            } else {
                currentNumber--;
            }
        }
        //console.log(currentNumber);
        if (currentNumber == 0) {
            $(this).parents('.colour-selector-col').find('.plus-minus-byo-form').addClass('d-none');
            $(this).parents('.colour-selector-col').find('.standard-add-form').removeClass('d-none');
        }
        $(this).parents('form').find('.current-basket-value').text(currentNumber);
        $(this).parents('form').find('input[name="NewQuantity"]').val(currentNumber);
        //return false;
        $(this).parents('form').submit();
    });

});

function CreateBuildYourOwnProductEnd(data) {
    if (data != null && data.responseJSON != null) {
        UpdateByoContent(data.responseJSON);
        $('.byoCreateArea').addClass('d-none');
        $('.byoCurrentArea, .byoProductsArea').removeClass('d-none');
    }
}
window.CreateBuildYourOwnProductEnd = CreateBuildYourOwnProductEnd;

var stickySlotsTimeout;
function EditBuildYourOwnProductEnd(data) {
    if (data != null && data.responseJSON != null) {
        UpdateByoContent(data.responseJSON);

        var stickySlots = $('.byoCurrentContentSlots-area--sticky .byoCurrentContentSlots');
        stickySlots.addClass('show');
        stickySlots.css('top', '');

        var ssHeaderHeight = $('.ss-header').height();
        var offset = $('.byoProductsArea').offset().top - $(document).scrollTop();

        if (ssHeaderHeight !== 0 && offset < ssHeaderHeight) {
            console.log(offset);
            console.log(ssHeaderHeight);

            var stickySlotsTop = stickySlots.position().top;
            console.log(stickySlotsTop);

            stickySlots.css('top', stickySlotsTop + ssHeaderHeight - Math.max(offset, 0));
        }

        clearTimeout(stickySlotsTimeout);
        stickySlotsTimeout = setTimeout(function () {
            if (!stickySlots.is(':hover')) {
                stickySlots.removeClass('show');
            }
        }, 2000);
    }
}
window.EditBuildYourOwnProductEnd = EditBuildYourOwnProductEnd;

function UpdateByoContent(json) {
    var CurrencySymbol = $('#CurrencySymbol').text();
    var CurrencyGroupSeparator = $('#CurrencyGroupSeparator').text();
    var CurrencyDecimalSeparator = $('#CurrencyDecimalSeparator').text();

    $('.byoCurrentContentTin').html(json.tinHtml);
    $('.byoCurrentContentSlots').html(json.slotHtml);
    $('.byoListPrice').text(accounting.formatMoney(json.listPrice, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator));
    $('.byoSaving').text(accounting.formatMoney(json.saving, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator));
    $('.byoPrice').text(accounting.formatMoney(json.price, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator));
    $('.byoCurrentArea input[name="sku"]').val(json.container.sku);
    $('.byoCurrentArea input[name="byoGuid"], .byoCurrentArea input[name="Guid"], .byoVariantProducts input[name="Guid"]').val(json.guid);
    $('.byo-favourite-button').data('guid', json.guid);
    //console.log(json.guid);

    if (json.isFull) {
        $('.byoAddItemButton').attr('disabled', true);
        $('.add-another-btn').attr('disabled', true);
        $('.add-to-cart-button').removeAttr('disabled');
        $('.byo-favourite-button').removeAttr('disabled');
    } else {
        $('.byoAddItemButton').removeAttr('disabled');
        $('.add-another-btn').removeAttr('disabled');
        $('.add-to-cart-button').attr('disabled', true);
        $('.byo-favourite-button').attr('disabled', true);
    }

    //reset plus-minus forms
    $('.byoVariantProducts .colour-selector-col .standard-add-form').removeClass('d-none');
    $('.byoVariantProducts .colour-selector-col .plus-minus-byo-form').addClass('d-none');

    if (json.items != null) {
        $.each(json.items, function (i, item) {
            $('.byoVariantProducts .colour-selector-col[data-sku="' + item.product.groupProdCode + '"]').find('.standard-add-form').addClass('d-none');
            $('.byoVariantProducts .colour-selector-col[data-sku="' + item.product.groupProdCode + '"]').find('.plus-minus-byo-form').removeClass('d-none');
            $('.byoVariantProducts .colour-selector-col[data-sku="' + item.product.groupProdCode + '"]').find('.plus-minus-byo-form .current-basket-value').text(item.totalQuantity);
            //console.log(item.product.groupProdCode);
        });
    }
}